import { Menu } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

const styles = makeStyles(() => ({
  clearDateIcon: {
    cursor: "pointer",
  },
  endAdornment: {
    paddingRight: "14px",
  },
  input: {
    "& .MuiOutlinedInput-input": {
      minWidth: "185px",
    },
  },
}));

export const StyledMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    background: "#F5F5F5",
    fontFamily: "Manrope !important",
    fontSize: 18,
    borderRadius: "16px",
    boxShadow: "0px 1px 2px rgba(0, 14, 51, 0.25)",
    "& .MuiMenu-list": {
      fontSize: 18,
    },
    "& .MuiMenuItem-root": {
      "& svg": {
        fontSize: 18,
        marginRight: 25,
      },
    },
  },
}));

export default styles;
